import { formatTimestampToDate } from '@/helper/filter/formatDate';

export const COMPANY = 'company';
export const NAME = 'name';
export const SALUTATION = 'salutation';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const TRADE_NAME = 'tradeName';
export const FOUNDING_DATE = 'foundingDate';
export const TURNOVER = 'turnover';
export const ONLINE_TURNOVER_RATE = 'onlineTurnoverRate';
export const FACTORABLE_TURNOVER = 'factorableTurnover';
export const CREDITOR_LIMIT = 'creditorLimit';
export const STREET_AND_HOUSE = 'streetAndHouse';
export const ZIP = 'zip';
export const CITY = 'city';
export const PHONE = 'phone';
export const MOBILE = 'mobile';
export const EMAIL = 'email';

export const LEGAL = 'legal';
export const ENTITLED_TO_DEDUCT_VAT = 'entitledToDeductVat';
export const VOB = 'vob';
export const REGISTER_NUMBER = 'registerNumber';
export const PLACE_OF_AUTHORITY = 'placeOfAuthority';
export const PROPRIETOR = 'proprietor';

export const SEPA = 'sepa';
export const ACCOUNT_OWNER = 'accountOwner';
export const IBAN = 'iban';
export const DATE = 'date';

export const INTERMEDIARY = 'intermediary';
export const ASSET_CONSULTANT = 'assetConsultant';
export const CONTACT_SALUTATION = 'contactSalutation';
export const CONTACT_FIRST_NAME = 'contactFirstName';
export const CONTACT_LAST_NAME = 'contactLastName';
export const INTERMEDIARY_STREET_AND_HOUSE = 'streetAndHouse';
export const INTERMEDIARY_ZIP = 'zip';
export const INTERMEDIARY_CITY = 'city';
export const INTERMEDIARY_PHONE = 'phone';
export const INTERMEDIARY_EMAIL = 'email';
export const DEPARTMENT = 'department';
export const ASSET_CONSULTANT_NUMBER = 'assetConsultantNumber';
export const INTERMEDIARY_NUMBER = 'intermediaryNumber';
export const NOTES = 'notes';
export const PRIVACY_POLICY_ACCEPTED = 'privacyPolicyAccepted';

export const CONTRACT = 'contract';
export const CONTRACT_DATE = 'contractDate';
export const LEGAL_FORM = 'legalForm';
export const LEGAL_FORM_KEY = 'key';
export const LEGAL_FORM_VALUE = 'value';
export const BUERGEL_SCORE = 'buergelScore';
export const CSP_IDENTIFIER = 'cspIdentifier';
export const DDM_IDENTIFIER = 'ddmIdentifier';
export const WZ_CODE = 'wzCode';
export const SET_UP_FEE = 'setUpFee';
export const MINIMUM_ANNUAL_SERVICE_FEE = 'minimumAnnualServiceFee';

export const CONDITIONS = 'conditions';
export const SERVICE_FEE_MATRIX_ID = 'serviceFeeMatrixIdentifier';

export const FORM_DATA_CONSTANTS = {
  COMPANY,
  NAME,
  SALUTATION,
  FIRST_NAME,
  LAST_NAME,
  TRADE_NAME,
  FOUNDING_DATE,
  TURNOVER,
  ONLINE_TURNOVER_RATE,
  FACTORABLE_TURNOVER,
  CREDITOR_LIMIT,
  STREET_AND_HOUSE,
  ZIP,
  CITY,
  PHONE,
  MOBILE,
  EMAIL,
  LEGAL,
  ENTITLED_TO_DEDUCT_VAT,
  VOB,
  REGISTER_NUMBER,
  PLACE_OF_AUTHORITY,
  PROPRIETOR,
  SEPA,
  ACCOUNT_OWNER,
  IBAN,
  DATE,
  INTERMEDIARY,
  ASSET_CONSULTANT,
  CONTACT_SALUTATION,
  CONTACT_FIRST_NAME,
  CONTACT_LAST_NAME,
  INTERMEDIARY_STREET_AND_HOUSE,
  INTERMEDIARY_ZIP,
  INTERMEDIARY_CITY,
  INTERMEDIARY_PHONE,
  INTERMEDIARY_EMAIL,
  PRIVACY_POLICY_ACCEPTED,
  DEPARTMENT,
  ASSET_CONSULTANT_NUMBER,
  INTERMEDIARY_NUMBER,
  CONTRACT,
  CONTRACT_DATE,
  LEGAL_FORM,
  LEGAL_FORM_KEY,
  LEGAL_FORM_VALUE,
  BUERGEL_SCORE,
  CSP_IDENTIFIER,
  DDM_IDENTIFIER,
  WZ_CODE,
  SET_UP_FEE,
  MINIMUM_ANNUAL_SERVICE_FEE,
  CONDITIONS,
  SERVICE_FEE_MATRIX_ID,
  NOTES
};

export const createCreditorFactory = () => ({
  [COMPANY]: {
    [NAME]: '',
    [SALUTATION]: '',
    [FIRST_NAME]: '',
    [LAST_NAME]: '',
    [TRADE_NAME]: '',
    [FOUNDING_DATE]: '',
    [TURNOVER]: '',
    [CREDITOR_LIMIT]: '',
    [ONLINE_TURNOVER_RATE]: '',
    [STREET_AND_HOUSE]: '',
    [ZIP]: '',
    [CITY]: '',
    [PHONE]: '',
    [MOBILE]: '',
    [EMAIL]: ''
  },
  [LEGAL]: {
    [ENTITLED_TO_DEDUCT_VAT]: '',
    [VOB]: '',
    [REGISTER_NUMBER]: '',
    [PLACE_OF_AUTHORITY]: '',
    [PROPRIETOR]: ''
  },
  [SEPA]: {
    [ACCOUNT_OWNER]: '',
    [IBAN]: '',
    [DATE]: formatTimestampToDate(Date.now() / 1000)
  },
  [INTERMEDIARY]: {
    [ASSET_CONSULTANT]: '',
    [CONTACT_SALUTATION]: '',
    [CONTACT_FIRST_NAME]: '',
    [CONTACT_LAST_NAME]: '',
    [INTERMEDIARY_STREET_AND_HOUSE]: '',
    [INTERMEDIARY_ZIP]: '',
    [INTERMEDIARY_CITY]: '',
    [INTERMEDIARY_PHONE]: '',
    [INTERMEDIARY_EMAIL]: '',
    [DEPARTMENT]: '',
    [ASSET_CONSULTANT_NUMBER]: '',
    [INTERMEDIARY_NUMBER]: '',
    [NOTES]: '',
    [PRIVACY_POLICY_ACCEPTED]: false
  },
  [CONTRACT]: {
    [CONTRACT_DATE]: '',
    [LEGAL_FORM]: {
      [LEGAL_FORM_KEY]: '',
      [LEGAL_FORM_VALUE]: ''
    },
    [BUERGEL_SCORE]: '',
    [CSP_IDENTIFIER]: '',
    [DDM_IDENTIFIER]: '',
    [WZ_CODE]: '',
    [SET_UP_FEE]: '',
    [MINIMUM_ANNUAL_SERVICE_FEE]: '',
    serviceFeePeriod: null,
    serviceFee: null
  },
  [CONDITIONS]: {
    [SERVICE_FEE_MATRIX_ID]: ''
  }
});

export default createCreditorFactory;
